<template>
  <div>
    <template v-if="!loading">
      <message-item
        v-for="message in messages"
        :key="message.id"
        :message="message"
        :type="type"
        class="mb-2"
        @seen="$emit('seen', $event)"
      />
    </template>
    <div v-else class="text-center p-5 w-100">
      <b-spinner variant="primary" label="Loading..." />
    </div>
  </div>
</template>

<script>
import MessageItem from './MessageItem.vue'

export default {
  name: 'MessagesList',

  props: {
    loading: {
      type: Boolean,
      default: false
    },

    type: {
      type: String,
      required: true
    },

    messages: {
      type: Array,
      default: () => ([])
    }
  },

  components: {
    MessageItem
  }
}
</script>
